import { DateTime, type DurationUnit } from 'luxon';

export const dateDiff = (date: string) => {
  const diff = DateTime.fromISO(date).diffNow();

  // This will produce numbers with decimal values. E.g. 1.125 days
  const getDiff = (duration: DurationUnit) => Math.abs(diff.as(duration));

  const weeks = getDiff('weeks');
  const days = getDiff('days');
  const hours = getDiff('hours');
  const minutes = getDiff('minutes');

  // Check for higher durations (e.g. months) first, getting smaller and more
  // granular with each check. This creates ranges between values
  if (weeks > 8) {
    return 'more than a month ago';
  } else if (weeks > 4) {
    return 'a month ago';
  } else if (weeks >= 2) {
    return `${Math.floor(weeks)} weeks ago`;
  } else if (weeks >= 1) {
    return 'a week ago';
  } else if (days > 2) {
    return `${Math.floor(days)}d ago`;
  } else if (days > 1) {
    return 'yesterday';
  } else if (hours > 3) {
    return 'today';
  } else if (hours >= 1) {
    return `${Math.floor(hours)}h ago`;
  } else if (minutes >= 15) {
    return 'less than an hour ago';
  } else if (minutes >= 1) {
    return `${Math.floor(minutes)}m ago`;
  }
  return 'few seconds ago';
};
